<template>
  <div class="automation-trigger-description-custom">
    A custom trigger
  </div>
</template>